import { render, staticRenderFns } from "./SchemaImageSelectPopup.vue?vue&type=template&id=c83e04a2&scoped=true&"
import script from "./SchemaImageSelectPopup.vue?vue&type=script&lang=js&"
export * from "./SchemaImageSelectPopup.vue?vue&type=script&lang=js&"
import style0 from "./SchemaImageSelectPopup.vue?vue&type=style&index=0&id=c83e04a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83e04a2",
  null
  
)

export default component.exports